import type { Locale } from "@/i18n/locales";

import {
  absoluteUrl,
  appStoreUrl,
  canonicalFor,
  CONTACT_EMAIL,
  PLAY_STORE_URL,
  SITE_NAME,
  SITE_URL,
} from "./site";

export const APP_STORE_APP_ID = "1229465470";

export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
    logo: absoluteUrl("/icon.png"),
    description:
      "Free digital vaccination record app for families, with reminders, travel health advice, and secure PDF exports.",
    email: CONTACT_EMAIL,
    founder: [
      { "@type": "Person", name: "Dr. Marco Goeijenbier" },
      { "@type": "Person", name: "Pim Bruijnes" },
    ],
    sameAs: [
      "https://www.linkedin.com/in/marco-goeijenbier-0b3a5927/",
      "https://www.linkedin.com/in/pim-bruijnes-a4857122/",
    ],
  };
}

export function mobileApplicationSchema(locale: Locale) {
  return {
    "@context": "https://schema.org",
    "@type": "MobileApplication",
    name: SITE_NAME,
    operatingSystem: "iOS, Android",
    applicationCategory: "HealthApplication",
    offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
    downloadUrl: [appStoreUrl(locale), PLAY_STORE_URL],
    installUrl: appStoreUrl(locale),
  };
}

export function websiteSchema(locale: Locale) {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: canonicalFor(locale, "/"),
    publisher: { "@type": "Organization", name: SITE_NAME, url: SITE_URL },
  };
}

export function homeJsonLd(locale: Locale) {
  return [
    organizationSchema(),
    websiteSchema(locale),
    mobileApplicationSchema(locale),
  ];
}

export function appJsonLd(locale: Locale) {
  return [organizationSchema(), mobileApplicationSchema(locale)];
}
